function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.6257,
  cy: 2.8184,
  rx: 2.3837,
  ry: 1.4831,
  fill: "none",
  stroke: "#5b2966",
  strokeWidth: 0.37042
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 2.6257,
  cy: 2.8184,
  r: 0.91406,
  fill: "#5b2966",
  stroke: "#5b2966",
  strokeWidth: 0.37042
});

function SvgEyeOn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 5.2917 5.2917",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOn);
export default __webpack_public_path__ + "static/media/eye_on.91816f61a90f9a78aad118f2d9c11e15.svg";
export { ForwardRef as ReactComponent };